// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","banner":"Home_banner__Cn6Ej","left_text":"Home_left_text__9J1MP","right_photo":"Home_right_photo__C3yTU"};